import * as reviewsService from '../services/reviews'

export const ACTIONS = {
  GET_REVIEWS_USER_REQUEST: 'GET_REVIEWS_USER_REQUEST',
  GET_REVIEWS_USER_SUCCESS: 'GET_REVIEWS_USER_SUCCESS',
  GET_REVIEWS_USER_FAILURE: 'GET_REVIEWS_USER_FAILURE',
  POST_REVIEWS_USER_REQUEST: 'POST_REVIEWS_USER_REQUEST',
  POST_REVIEWS_USER_SUCCESS: 'POST_REVIEWS_USER_SUCCESS',
  POST_REVIEWS_USER_FAILURE: 'POST_REVIEWS_USER_FAILURE',
}

export const GET_REVIEWS_USER_REQUEST = () => ({
  type: ACTIONS.GET_REVIEWS_USER_REQUEST,
})

export const GET_REVIEWS_USER_SUCCESS = (reviews) => ({
  type: ACTIONS.GET_REVIEWS_USER_SUCCESS,
  reviews,
})

export const GET_REVIEWS_USER_FAILURE = (err) => ({
  type: ACTIONS.GET_REVIEWS_USER_FAILURE,
  err,
})

export function getReviews(data) {
  return (dispatch) => {
    dispatch(GET_REVIEWS_USER_REQUEST())

    return reviewsService.getReviews(data).then(
      (response) => dispatch(GET_REVIEWS_USER_SUCCESS(response)),
      (err) => dispatch(GET_REVIEWS_USER_FAILURE(err))
    )
  }
}

export const POST_REVIEWS_USER_REQUEST = () => ({
  type: ACTIONS.POST_REVIEWS_USER_REQUEST,
})

export const POST_REVIEWS_USER_SUCCESS = (address) => ({
  type: ACTIONS.POST_REVIEWS_USER_SUCCESS,
  address,
})

export const POST_REVIEWS_USER_FAILURE = (err) => ({
  type: ACTIONS.POST_REVIEWS_USER_FAILURE,
  err,
})

export function postReviews(data) {
  return (dispatch) => {
    dispatch(POST_REVIEWS_USER_REQUEST())

    return reviewsService.postReviews(data).then(
      (response) => dispatch(POST_REVIEWS_USER_SUCCESS(response)),
      (err) => dispatch(POST_REVIEWS_USER_FAILURE(err))
    )
  }
}
